import { request } from './service'
export default {
    COMMON() {
        return request({
            url: '/index/common',
            method: 'get',
        })
    },
    INDEX() {
        return request({
            url: '/index/index',
            method: 'get',
        })
    },
    CATE(id,params) {
        return request({
            url: '/index/cate/' + id,
            method: 'get',
            params
        })
    },
    AD(id) {
        return request({
            url: '/index/ad/' + id,
            method: 'get'
        })
    },
    INFO({cate='', id=''}) {
        return request({
            url: '/index/info/' + cate + '/' + id,
            method: 'get'
        })
    },
    APPLY(data){
        return request({
            url:'/index/apply',
            method:'post',
            data
        })
    },
    FILE(data){
        return request({
            url:'/index/upload/file',
            method:'post',
            header:{
               'Content-Type' :'application/json'
            },
            data
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/apis.js